import path from 'path';
import _ from 'lodash';
import ProjectService from '../api/project';
import mElectron from '../../util/electron';
import Config from '../../config';
import Emitter from '../../services/emitter';

class ProjectLocal {
    /**
     * 定时检测是否有projects修改并写入Json
     * @memberof ProjectLocal
     */
    constructor() {
        this.instance = null;
        this.timer = null;
        this.localList = null;
        this.isChange = false;
        this.isInitFinish = false;
        if (_.has(window, `window.MbApi.file`)) {
            //  TODO: 该逻辑是否可以不放在构造函数里实现
            this.initTimer();
        }
    }

    static getInstance() {
        if (!ProjectLocal.instance) {
            ProjectLocal.instance = new ProjectLocal();
        }
        return ProjectLocal.instance;
    }

    initTimer() {
        this.read().then(() => {
            Emitter.emit('Project.Local.isFinish');
            this.isInitFinish = true;
            this.timer = setInterval(() => {
                return this.write();
            }, 1000);
        });

    }

    async write(immediately = false) {
        if (immediately || this.isChange) {
            await ProjectService.write.call(ProjectService, this.localList, 'save');
            this.isChange = false;
        }
    }

    async read() {
        const filePath = path.join(Config.userProjectFilePath, Config.userProjectFileName);
        const res = await mElectron.read(filePath);
        if (res && res.data && res.data.length > 0) {
            const data = res.data;
            const localList = {};
            data.forEach((d) => {
                if (localList[d.userId]) {
                    localList[d.userId].push(d);
                } else {
                    localList[d.userId] = [];
                    localList[d.userId].push(d);
                }
            });
            this.localList = localList;
        } else {
            this.localList = {};
        }
    }

    set(localList) {
        if (_.isEqual(localList, this.localList)) {
            this.isChange = false;
        } else {
            this.localList = _.cloneDeep(localList);
            this.isChange = true;
        }
    }

    get() {
        return new Promise ((resolve) => {
            let newLocalList = _.cloneDeep(this.localList);
            if (this.isInitFinish) {
                resolve(newLocalList);
            } else {
                Emitter.on('Project.Local.isFinish', () => {
                    newLocalList = _.cloneDeep(this.localList);
                    resolve(newLocalList);
                });
            }
        });
    }
}

let projectLocal = ProjectLocal.getInstance();

window.projectLocal = projectLocal;

export default projectLocal;